<template>
  <div :class="`${variant} progress-wrapper`">
    <div :style="rangeStyle" class="range">
      <span v-if="showUsageValue"> {{ progress }}% </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    variant: {
      type: String,
      default: 'primary',
    },
    showUsageValue: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: '',
    },
  },
  computed: {
    rangeStyle() {
      return {
        width: `${this.progressWidth}%`,
        backgroundColor: this.variant === 'range-color' ? this.color : null,
      };
    },
    // case: width can't be more than 100%
    progressWidth() {
      return this.progress > 100 ? 100 : this.progress;
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-wrapper {
  white-space: nowrap;
}
.primary {
  background-color: rgba($color: $color-red, $alpha: 0.2);

  .range {
    background-color: $color-red;
  }
}

.secondary {
  background-color: rgba($color: $progress-green, $alpha: 0.2);

  .range {
    background-color: $progress-green;
  }
}
.range-color {
  background-color: #2d3032;
  .range {
    background-color: $progress-green;
  }
}
.range {
  padding: 0.3rem 0;

  span {
    padding: 0 0.3rem;
  }
}
</style>
